import { Cartesian3, Math as CesiumMath } from "cesium";
import { CylinderEntity } from "../services/entity-editors/map-entities-editor.service";

export function areCylinderEntitiesPositionsEqual(left: CylinderEntity, right: CylinderEntity): boolean {
    if (!Cartesian3.equalsEpsilon(left.center, right.center, CesiumMath.EPSILON6)) {
        return false;
    }

    if (left.radius !== right.radius) {
        return false;
    }

    return true;
}
